import { Map } from 'immutable'

export const EMAIL_RECOMMENDATION_CLICK_ATTRIBUTION = 'Email Recommendation'

/**
 * Read a Recombee recommendation id from resolver or location query params.
 * Supports `recommId` (canonical) and `recomm_id` (alias).
 * @param {import('immutable').Map|Record<string, unknown>|null|undefined} query
 * @returns {string|null}
 */
export function parseRecommIdFromQuery (query) {
  if (!query) {
    return null
  }
  const raw = Map.isMap(query)
    ? (query.get('recommId') ?? query.get('recomm_id'))
    : (query.recommId ?? query.recomm_id)
  if (raw == null) {
    return null
  }
  const trimmed = String(raw).trim()
  return trimmed === '' ? null : trimmed
}

/**
 * @param {string} recommId
 * @returns {{ recommId: string, clickAttribution: string }}
 */
export function buildEmailRecommIdUpstreamContextData (recommId) {
  return {
    recommId,
    clickAttribution: EMAIL_RECOMMENDATION_CLICK_ATTRIBUTION,
  }
}

/**
 * @param {import('immutable').Map|Record<string, unknown>|null|undefined} query
 * @returns {Record<string, unknown>}
 */
export function stripRecommIdQueryParams (query) {
  if (!query) {
    return {}
  }
  const base = Map.isMap(query) ? query.toJS() : { ...query }
  const rest = { ...base }
  delete rest.recommId
  // eslint-disable-next-line camelcase -- URL query alias for Recombee email links
  delete rest.recomm_id
  return rest
}
